import { render, staticRenderFns } from "./RelayPumpDialog.vue?vue&type=template&id=228c2cbd&scoped=true"
import script from "./RelayPumpDialog.vue?vue&type=script&lang=js"
export * from "./RelayPumpDialog.vue?vue&type=script&lang=js"
import style0 from "./RelayPumpDialog.vue?vue&type=style&index=0&id=228c2cbd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228c2cbd",
  null
  
)

export default component.exports